(() => {
  if (customElements.get('jj-product-purchase')) return;
  class ProductPurchase extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('[name="quantity"]');
      this.idInput = this.querySelector('[data-purchase-id]');
      this.button = this.querySelector('[type="submit"]');
      this.companion = this.querySelector('[data-companion]');
      await customElements.whenDefined('product-form');
      if (this.companion) {
        const prepare = this.form.prepareFormData.bind(this.form);
        this.form.prepareFormData = (data) => {
          const order = prepare(data);
          order.items.forEach(item => { item.quantity = Number(this.quantity.value) || 1; });
          return order;
        };
      }
      this.querySelector('[data-kit-choice]')?.removeAttribute('hidden');
      const defaultKit = this.querySelector('[name="purchase_choice"][value="kit"]');
      if (defaultKit) defaultKit.checked = true;
      this.addEventListener('change', () => this.update());
      this.addEventListener('input', event => {
        if (event.target === this.quantity && this.quantity.validity.valid) this.update();
      });
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-quantity-step]');
        if (!step) return;
        this.quantity.value = Math.max(1, (Number(this.quantity.value) || 1) + Number(step.dataset.quantityStep));
        this.update();
      });
      this.update();
    }
    update() {
      const choice = this.querySelector('[name="purchase_choice"]:checked');
      const single = this.querySelector('[name="purchase_choice"][value="single"]');
      const isKit = choice.value === 'kit';
      const isBase = this.dataset.mode === 'base';
      const colors = this.querySelector('[data-kit-colors]');
      const color = this.querySelector('[name="bottle_color"]:checked');
      const qty = Math.max(1, Number(this.quantity.value) || 1);
      if (colors) {
        colors.hidden = !isKit;
        colors.disabled = !isKit;
        this.querySelector('[data-color-label]').textContent = color?.dataset.title || '';
      }
      this.idInput.value = isKit && !isBase ? color.value : single.dataset.variant;
      if (this.companion) {
        this.companion.checked = isKit;
        this.companion.value = color?.value || '';
      }
      this.querySelector('[data-quantity-step="-1"]').disabled = qty <= 1;
      const amount = Number(choice.dataset.price) * qty / 100;
      const price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency,
        minimumFractionDigits: amount % 1 ? 2 : 0, maximumFractionDigits: 2
      }).format(amount);
      const available = choice.dataset.available === 'true' && (!isKit || (color && !color.disabled));
      this.button.disabled = !available;
      const label = isKit ? (qty > 1 ? `${qty} kits` : 'kit') : this.dataset.singleName;
      this.querySelector('[data-add-label]').textContent = available ? `Add ${label} · ${price}` : 'Sold out';
      const contents = isKit
        ? (isBase ? `${qty} Base tub${qty > 1 ? 's' : ''} + ${qty} bottle${qty > 1 ? 's' : ''} + ${qty} Unroll tin${qty > 1 ? 's' : ''}`
          : `${qty} bottle${qty > 1 ? 's' : ''} + ${qty} Energy tin${qty > 1 ? 's' : ''}`)
        : `${qty} ${isBase ? 'tub' : 'tin'}${qty > 1 ? 's' : ''}`;
      this.button.setAttribute('aria-label', available ? `Add ${contents}${isKit ? ', ' + color.dataset.title : ''} to cart for ${price}` : 'Sold out');
      this.querySelector('[data-order-note]').textContent = `${contents}. One-time purchase.`;
    }
  }
  customElements.define('jj-product-purchase', ProductPurchase);
})();
